<template>
  <v-dialog :width="width || 600" scroll-strategy="reposition">
    <slot />
  </v-dialog>
</template>

<script setup lang="ts">
defineProps<{
  width?: number;
}>();
</script>